var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 7.58333L19.0352 7.91667C18.2312 5 16.8643 3.33333 14.4523 3.33333H11.3166C11.1558 5.25 11.0754 8.33333 11.1558 11.5833L13.2462 11.5C14.6935 11.5 15.2563 10.4167 15.5779 8.75H16.3819V15.5H15.5779C15.2563 13.8333 14.6131 12.75 13.2462 12.6667H11.1558C11.1558 15.0833 11.1558 17.1667 11.3166 18.4167C11.4774 20.25 11.8794 21 13.1658 21.1667L14.2915 21.25V22H4V21.25L4.88442 21.1667C6.09045 21 6.57286 20.1667 6.73367 18.4167C6.89447 15.4167 6.89447 9.16667 6.65327 5.66667C6.49246 3.83333 6.01005 3.08333 4.80402 2.91667L4 2.83333V2H20V7.58333Z",
    fill: "#020617"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconF);
export default __webpack_public_path__ + "static/media/icon-f.d7ccd785316444ff5924fef17eb3d1f7.svg";
export { ForwardRef as ReactComponent };